<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { FeatureContactPageForm } from '~/components/feature/contact-page/form'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetCustomerCare } from '~/components/widget/customer-care'
import { WidgetFrequentlySearched } from '~/components/widget/frequently-searched'
import type { IResponseData } from '~/types'
import type { IUser } from '~/components/entity/user'
import { WidgetUser } from '~/components/widget/user'
import { WidgetTelegram } from '~/components/widget/telegram'
import { WidgetInstagram } from '~/components/widget/instagram'

const { t } = useI18n()

const queryParams = {
  'filter[id]': [7, 2]
}

const { data } = useApi<IResponseData<IUser[]>>(() => useUrlWithParams('/users', queryParams), {
  key: 'contacts_users_list'
})

const contactUsers = computed(() => {
  return data.value?.data || []
})

const breadcrumbs = computed(() => [{ title: t('common.feedback'), url: '/contacts' }])
</script>

<template>
  <div>
    <Main>
      <Container>
        <WidgetBreadcrumbs :links="breadcrumbs" />
        <ContentLayout>
          <template #right-sidebar>
            <aside>
              <WidgetCustomerCare />
              <WidgetTelegram />
              <WidgetInstagram />
              <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
            </aside>
          </template>
          <div class="lg:col-span-3" role="main">
            <ContentBlock variant="white">
              <Heading tag="h1">{{ $t('common.feedback') }}</Heading>
              <Content>
                <p>
                  <i18n-t keypath="page.contacts.intro" scope="global">
                    <template #strong>
                      <strong>Banks.kg</strong>
                    </template>
                    <template #br>
                      <br />
                    </template>
                  </i18n-t>
                </p>
              </Content>
              <template v-if="contactUsers && contactUsers.length">
                <Heading tag="h2" class="h3">{{ $t('common.contacts_for_communication') }}</Heading>
                <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
                  <WidgetUser
                    v-for="member in contactUsers"
                    :key="member.id"
                    variant="grey"
                    v-bind="member"
                  />
                </div>
              </template>
              <FeatureContactPageForm
                :heading-text="$t('common.write_us')"
                heading-tag="h2"
                heading-class="h3"
              />
            </ContentBlock>
          </div>
        </ContentLayout>
      </Container>
    </Main>
    <WidgetFrequentlySearched />
  </div>
</template>
